import React from 'react';
import { getProfileImageLink, isDashboard } from '../utils/Connections';
import dispatcher from '../utils/dispatcher';

let padding = {
    padding: "5%"
}
const OptionButton = ({title="Profile",icon="lnr-user",onClick}) => {
    return(
        <div onClick={()=>onClick?onClick():null} style={{cursor:"pointer",width:60}}>
            <div style={{border:"1px solid #375139",borderRadius:"100%",width:60,height:60,display:"flex",justifyContent:"center",alignItems:"center"}}>
                <span className={`lnr ${icon}`} style={{color:"#375139",fontSize:18}}/>
            </div>
            <div style={{fontFamily:"mainFont",textTransform:"capitalize", color:"#375139",textAlign:"center",fontSize:13}}>
                {title}
            </div>
        </div>
    )
}
const startChat = (data) => dispatcher.dispatch({type: "SELECT_CHAT_USER",payload:data});

const FarmerCard = ({farmer,fullProfileRequest,fundFarmerRequest,allFarmerVouchers,enableSprayingProgram,isMyFarmer=false}) => {
    const getFarmerImage=(imageName)=>getProfileImageLink() + imageName;

    return(
        <div className="col-sm-4 col-md-3 col-lg-3 col-xl-3 farmer-card">
            <div className="farmer-card-inner">

                <div className="farmer-card-img"
                     style={{backgroundImage: "http://dashboard.khula.co.za/images/vegetables.png"}}>
                    <div className="">
                        <img alt="farmer" src={getFarmerImage(farmer.image_name)}/>
                    </div>
                    <div className="farmertop" style={padding}>
                        <h5>{farmer.name + " " + farmer.surname}</h5>
                    </div>
                    {
                        isMyFarmer &&
                        <div style={{display: "flex",
                                alignItems: "center",
                                flex: 1,
                                color: "white",
                                fontSize: 22,
                                justifyContent: "flex-end"}}
                        >
                            <span onClick={()=>startChat({userId:farmer.id,userName:`${farmer.name} ${farmer.surname}`})}
                                  className="lnr lnr-envelope"
                                  style={{cursor:"pointer"}}
                            />
                        </div>
                    }
                </div>


                <div className="farmer-card-content">
                    <div className="content">
                    </div>
                    <div className="content">
                        <p><span className="lnr lnr-chevron-right"></span>Farm
                            Size: {farmer.farmSize} hectares
                            <br/> <span className="lnr lnr-chevron-right"></span>Produce
                            Type: {farmer.produceType}
                            <br/> <span className="lnr lnr-chevron-right"></span>Funding
                            needs: {farmer.fundingFor}
                        </p>
                    </div>
                </div>

                <div className="buttoncontainer">
                    <OptionButton title="Profile" icon="lnr-user" onClick={() => fullProfileRequest(farmer.id, farmer)}/>
                    <OptionButton title="Send Voucher" icon="lnr-book" onClick={() => fundFarmerRequest(farmer.id, farmer)}/>
                    <OptionButton title="Track Funds" icon="lnr-page-break" onClick={() => allFarmerVouchers(farmer.id, farmer)}/>
                    {!isDashboard() && enableSprayingProgram && <OptionButton title="Suggest Spraying Programme" icon="lnr-chart-bars" onClick={() => enableSprayingProgram(farmer)}/>}
                </div>
            </div>
        </div>
    )
}

export default FarmerCard;


// WEBPACK FOOTER //
// ./src/components/FarmerCard.js